import { render } from "./JudgeDetail.vue?vue&type=template&id=6279cc48&scoped=true"
import script from "./JudgeDetail.vue?vue&type=script&lang=js"
export * from "./JudgeDetail.vue?vue&type=script&lang=js"

import "./JudgeDetail.vue?vue&type=style&index=0&id=6279cc48&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6279cc48"]])

export default __exports__